import * as types from "./mutation-types";

export default {
  [types.ADD_ITEM](state, item) {
    //alert('ddd');
    state.itemstest.push(item);
    //alert(state.itemstest.length);
  }
};
